import React, { ReactNode } from 'react';
import {
    Box,
    EmptyState,
    EmptyStateDescription,
    EmptyStateIllustration,
    EmptyStateTitle,
    tokens,
} from '@vp/swan';

interface ReferenceProjectsEmptyStateProps {
    illustrationType: 'myProjects' | 'error';
    title: string;
    description?: string;
    children?: ReactNode;
}

export const ReferenceProjectsEmptyState: React.FC<ReferenceProjectsEmptyStateProps> = ({
    illustrationType,
    title,
    description,
    children,
}) => {
    return (
        <Box
            style={{
                paddingTop: tokens.SwanSemSpaceBetweenSubsections,
                paddingBottom: tokens.SwanSemSpaceBetweenSubsections,
            }}
        >
            <EmptyState>
                <EmptyStateIllustration illustrationType={illustrationType} />
                <EmptyStateTitle>{title}</EmptyStateTitle>
                {description && <EmptyStateDescription>{description}</EmptyStateDescription>}
                {children && <Box style={{ marginTop: tokens.SwanSemSpace3 }}>{children}</Box>}
            </EmptyState>
        </Box>
    );
};
